//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
// autopilot-form-toggle
// util
import { TrackingEvents, track } from "#webapp/src/util/analytics.util";
import { articleUrls } from "@clockwise/client-commons/src/constants/help-center";
import { TranslationContext } from "@clockwise/client-commons/src/providers/TranslationContext";
import { colors, greys } from "@clockwise/web-commons/src/styles/color.styles";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
  container: {
    color: greys.lightishGrey,
    fontSize: 12,
    lineHeight: `16px`,
  },
  link: {
    color: colors.blueCool.standard,
    textDecoration: "none",
    transition: "color .3s",
    "&:hover": {
      color: colors.blueDusk.darker,
    },
  },
});

//////////////////
// COMPONENT
//////////////////
export function AutopilotFormLearnMore() {
  const classes = useStyles();
  const t = React.useContext(TranslationContext);

  const onClick = () => {
    track(TrackingEvents.HELP.AUTOPILOT);
  };

  return (
    <div className={classes.container}>
      <span>Learn&nbsp;</span>
      <a
        className={classes.link}
        href={articleUrls.autopilot}
        target="_blank"
        onClick={onClick}
        cw-id="autopilot-learn-more-link"
        rel="noreferrer"
      >
        {t("autopilot-form:learn-more-link")}
      </a>
      <span>&nbsp;{t("autopilot-form:learn-more-text")}</span>
    </div>
  );
}
